import { pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import { relations } from 'drizzle-orm'
import { getBaseFields, getBaseIndexes, typedJsonb } from '../common/utils'
import { customerMembers } from './customerMember'
import { properties } from './property'

// Customer type enum
export const customerTypeEnum = pgEnum('customer_type', [
  'household',
  'housing_company',
  'company',
])

// Customer status enum
export const customerStatusEnum = pgEnum('customer_status', [
  'active',
  'paused',
  'churned',
])

// Billing method enum
export const billingMethodEnum = pgEnum('billing_method', ['email', 'einvoice'])

export const customers = pgTable(
  'customers',
  {
    ...getBaseFields(),
    name: text().notNull(),
    type: customerTypeEnum().notNull().default('household'),
    status: customerStatusEnum().notNull().default('active'),
    notes: text(),
    stripeCustomerId: text(),
    billingMethod: billingMethodEnum().notNull().default('email'),
    billingEmail: text(),
    // Marketing attribution captured the first time we created this customer.
    // Write-once: never overwritten on subsequent bookings or opportunity
    // conversions. `internal` prefix hides this from non-staff roles per the
    // CLAUDE.md internal-field convention — homeowners with the 'user' role
    // must not see the UTM/referrer chain that acquired them.
    internalFirstTouchAcquisition: typedJsonb(
      'internal_first_touch_acquisition',
    ),
  },
  (table) => getBaseIndexes('customers', table),
)

export const customersRelations = relations(customers, ({ many }) => ({
  members: many(customerMembers),
  properties: many(properties),
}))
